import { useTranslation } from 'react-i18next'
import { Mail } from 'lucide-react'
import { Input, Label } from '@/components/ui'
import { sanitizeInput, sanitizeEmail } from '@/utils/validation'

interface CheckoutCustomerFormProps {
  firstName: string
  onFirstNameChange: (value: string) => void
  emailInput: string
  onEmailChange: (value: string) => void
  isEmailVerified: boolean
}

export function CheckoutCustomerForm({
  firstName,
  onFirstNameChange,
  emailInput,
  onEmailChange,
  isEmailVerified,
}: CheckoutCustomerFormProps) {
  const { t } = useTranslation()

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold">{t('common:yourInformation')}</h2>
      <div>
        <Label htmlFor="ck-name" className="text-sm font-medium">{t('common:name')}</Label>
        <Input
          id="ck-name"
          placeholder={t('common:optional')}
          value={firstName}
          onChange={(e) => onFirstNameChange(sanitizeInput(e.target.value).slice(0, 50))}
          maxLength={50}
          autoComplete="given-name"
          className="mt-1"
        />
      </div>
      <div>
        <Label htmlFor="ck-email" className="text-sm font-medium">
          {t('common:emailAddress')}{' '}
          <span className="font-normal text-muted-foreground">— {t('common:emailOptionalHint')}</span>
        </Label>
        <div className="flex items-center gap-2 mt-1">
          <Input
            id="ck-email"
            type="email"
            placeholder="you@example.com"
            value={emailInput}
            onChange={(e) => onEmailChange(sanitizeEmail(e.target.value))}
            maxLength={254}
            autoComplete="email"
          />
          {isEmailVerified && (
            <span className="flex items-center gap-1 text-xs font-medium text-green-600 shrink-0">
              <Mail className="h-3.5 w-3.5" />{t('common:verified')}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
